require('./bootstrap')

// Import function
import 'es6-promise/auto'
import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import Toasted from 'vue-toasted'
import { VueMaskDirective } from 'v-mask'
import VueProgressBar from 'vue-progressbar'
import axios from 'axios'

// Import Main App Wrapper
import App from './components/App.vue'
import ContinueButton from './components/ContinueButton.vue'
import Question from './components/Question.vue'
import TruePanel from './components/TruePanel.vue'
import InlineAdvice from './components/InlineAdvice.vue'

Vue.use(VueMask)
Vue.use(Toasted)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC1o5ybaE9jncRcFRjW5o52zubisAg3HJU',
        libraries: 'places' // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
    }
})

// As a directive
Vue.directive('mask', VueMaskDirective)

// Register Vue components
Vue.component('continue-button', ContinueButton)
Vue.component('question', Question)
Vue.component('true-panel', TruePanel)
Vue.component('inline-advice', InlineAdvice)

// Sync vue-router to vuex bindings
sync(store, router)

// Vue progress bar 
const options = {
    color: '#0D63A8',
    failedColor: '#874b4b',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    inverse: false
}
Vue.use(VueProgressBar, options)

Vue.prototype.$axios = axios

const app = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App),
    mounted() {
        this.$store.state.emptyAreaOfConcern = {
            ...this.$store.state.areaOfConcern
        }
        this.$store.state.uuid = window.trueUUID

        if (leadPreloaded && Object.keys(leadPreloaded).length > 0) {
            // Set deafult lead to capture new properties
            // this.$store.dispatch( 'applyLeadBindingsFromStorage', store.state.lead )
            // Apply the values from storage
            // this.$store.dispatch( 'applyLeadBindingsFromStorage', JSON.parse(leadPreloaded) )
        }

        // Initialize Intercom
        window.Intercom('boot', {
            app_id: 'euiv5ibc'
        })
    }
})

window.app = app

/**
 * Add global toSlug method to string
 */
String.prototype.toSlug = function() {
    let st = this.toLowerCase()
    st = st.replace(/[\u00C0-\u00C5]/gi, 'a')
    st = st.replace(/[\u00C8-\u00CB]/gi, 'e')
    st = st.replace(/[\u00CC-\u00CF]/gi, 'i')
    st = st.replace(/[\u00D2-\u00D6]/gi, 'o')
    st = st.replace(/[\u00D9-\u00DC]/gi, 'u')
    st = st.replace(/[\u00D1]/gi, 'n')
    st = st.replace(/[^a-z0-9 ]+/gi, '')
    st = st.trim().replace(/ /g, '-')
    st = st.replace(/[\-]{2}/g, '')
    return st.replace(/[^a-z\- ]*/gi, '')
}

let lengthOfScroll = 750

window.scrollToContent = (el, adjustment) => {
    let offset = el.offset().top
    if (adjustment) {
        offset = el.offset().top + adjustment
    }
    if (el.length > 0) {
        $('html, body').animate(
            {
                scrollTop: offset
            },
            lengthOfScroll
        )
    }
}

function scrollToHeight(offset, adjustment) {
    if (adjustment) {
        offset = offset + adjustment
    }
    $('html, body').animate(
        {
            scrollTop: offset
        },
        lengthOfScroll
    )
}

// app.$store.dispatch('getEquipmentItems')

// Watch for changes to the lead object and store it in a cookie

// Scroll to the top of the page whenever the route changes
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
    document.activeElement.blur()
    app.$store.state.previousRoute = from.path

    // Set page for Google Analytics
    gtag('config', 'UA_112535944_1', { page_path: to.path })
    ga('gtag_UA_112535944_1.set', 'page', to.path)
    ga('gtag_UA_112535944_1.send', 'pageview', to.path)
    // Catch all
    gtag('event', 'conversion', {'send_to': 'AW-879819493/T66SCJL764IBEOX1w6MD'});

    // Update intercom on page change
    window.Intercom('update')
})

Intercom('onShow', function() {
    // record event
    const eventName = 'Chat_ButtonClick'
    const eventParameters = {}
    // Do tracking
    fbq('trackCustom', eventName, eventParameters)
    gtag('event', eventName, eventParameters)
    gtag('event', 'conversion', { 'send_to': 'AW-879819493/kERvCMXEkoMBEOX1w6MD' });
});

// Pass name or email throgh query params
if (app.$route.query.name) {
    store.state.lead.name = app.$route.query.name
}
if (app.$route.query.email) {
    store.state.lead.email = app.$route.query.email
}

// Handle Signup or Login Events
if (app.$route.query.mixpanel) {
    const mixpanelType = app.$route.query.mixpanel
    const user = trueUser
    let name = user.name
    let email = user.email
    let nameSplit = name.split(' ')
    let firstName = ''
    let lastName = ''

    if (nameSplit.length > 1) {
        firstName = nameSplit[0]
        lastName = nameSplit[1]
    }

    let userData = {
        $email: email,
        name: name,
        phone: user.phone,
        $first_name: firstName,
        $last_name: lastName
    }

    Intercom('update', {
        name: name,
        email: email,
        phone: user.phone,
        $adminUrl: window.appUrl + '/admin/leads/' + this.uuid
    });

    mixpanel.register({
        "email": email,
        "name": name,
        "phone": user.phone,
    });

    gtag('event', 'conversion', { 'send_to': 'AW-879819493/5lMrCNW8y3sQ5fXDowM' });

    if (mixpanelType === 'identify') { 
        mixpanel.track('LoggedIn')
        mixpanel.identify(email) 
    }
    if (mixpanelType === 'alias') {
        mixpanel.track('signedUp')
        mixpanel.alias(email) 
    }
    mixpanel.people.set(userData)
}
